import React, { useEffect } from 'react';

const EmbedTestPage: React.FC = () => {
  useEffect(() => {
    const SUPABASE_URL = 'https://utafetamgwukkbrlezev.supabase.co';
    const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV0YWZldGFtZ3d1a2ticmxlemV2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk4NjgzMDAsImV4cCI6MjA3NTQ0NDMwMH0.6ycEWh2sLck45S8zjzNU0GqHTu_P1hh86YvP43E-Jk4';
    const TALENT_USERNAME = 'chrissalcedo';
    const container = document.getElementById('so-rumble-card');
    if (!container) return;

    container.innerHTML = '<div style="color:#6b7280;font-size:12px;">Loading...</div>';

    fetch(`${SUPABASE_URL}/rest/v1/talent_profiles?username=eq.${TALENT_USERNAME}&select=id`, {
      headers: { 'apikey': SUPABASE_KEY, 'Authorization': `Bearer ${SUPABASE_KEY}` }
    })
    .then(r => r.json())
    .then(profiles => {
      if (!profiles?.length) return;
      return fetch(`${SUPABASE_URL}/rest/v1/rumble_cache?talent_id=eq.${profiles[0].id}&select=*`, {
        headers: { 'apikey': SUPABASE_KEY, 'Authorization': `Bearer ${SUPABASE_KEY}` }
      });
    })
    .then(r => r?.json())
    .then(data => {
      if (!data?.length || !container) return;
      const v = data[0];
      const views = v.latest_video_views >= 1000 ? (v.latest_video_views / 1000).toFixed(1) + 'K' : (v.latest_video_views || 0);
      container.innerHTML = `<a href="${v.latest_video_url || v.channel_url || '#'}" target="_blank" rel="noopener noreferrer" style="text-decoration:none;display:block;max-width:400px;">
        <div style="background:linear-gradient(135deg,rgba(34,197,94,0.12),rgba(16,24,40,0.95));border:1px solid rgba(34,197,94,0.25);border-radius:16px;overflow:hidden;transition:transform 0.2s;cursor:pointer;">
          <div style="position:relative;">
            ${v.latest_video_thumbnail ? `<img src="${v.latest_video_thumbnail}" style="width:100%;aspect-ratio:16/9;object-fit:cover;display:block;" alt="${v.latest_video_title || ''}">` : ''}
            ${v.is_live ? '<div style="position:absolute;top:8px;left:8px;background:#ef4444;color:#fff;font-size:11px;font-weight:700;padding:2px 8px;border-radius:4px;">LIVE</div>' : ''}
            <div style="position:absolute;top:8px;right:8px;background:rgba(0,0,0,0.7);border-radius:6px;padding:4px 8px;display:flex;align-items:center;gap:4px;">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#85efac" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              <span style="color:#85efac;font-size:12px;font-weight:600;">${views} views</span>
            </div>
          </div>
          <div style="padding:12px 14px;display:flex;align-items:center;gap:10px;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#22c55e"><path d="M21.2 8.1c-.3-1.1-1-2-2-2.3C17.5 5.3 12 5.3 12 5.3s-5.5 0-7.2.5c-1 .4-1.7 1.2-2 2.3C2.3 9.8 2.3 12 2.3 12s0 2.2.5 3.9c.3 1.1 1 2 2 2.3 1.7.5 7.2.5 7.2.5s5.5 0 7.2-.5c1-.4 1.7-1.2 2-2.3.5-1.7.5-3.9.5-3.9s0-2.2-.5-3.9z"/><path d="M10 15l5-3-5-3v6z" fill="#fff"/></svg>
            <div style="flex:1;min-width:0;">
              <div style="color:#fff;font-size:14px;font-weight:600;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${v.latest_video_title || 'Watch on Rumble'}</div>
              <div style="color:#6b7280;font-size:11px;margin-top:2px;">Watch on Rumble</div>
            </div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
          </div>
        </div>
      </a>`;
    })
    .catch(() => {
      if (container) {
        container.innerHTML = '<a href="https://rumble.com/c/TheChrisSalcedoShow" target="_blank" rel="noopener noreferrer" style="text-decoration:none;display:block;max-width:400px;"><div style="background:#0f1923;border:1px solid rgba(34,197,94,0.25);border-radius:16px;padding:16px;text-align:center;"><div style="color:#22c55e;font-size:14px;font-weight:600;">Watch on Rumble</div></div></a>';
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center p-4">
      <h1 className="text-2xl font-bold text-white mb-6">Rumble Card Embed Test</h1>
      <div id="so-rumble-card" style={{ maxWidth: 400, width: '100%' }} />
      <p className="text-gray-500 text-sm mt-6">This is the embeddable Rumble card for Chris Salcedo</p>
    </div>
  );
};

export default EmbedTestPage;
